import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { Capacitor } from "@capacitor/core";

/**
 * Save a Blob to the device (native) or trigger a browser download (web).
 * On native: writes to Documents directory and opens with the default app.
 * On web: creates a temporary anchor to trigger a file download.
 */
export const saveBlob = async ({
  blob,
  fileName,
}: {
  blob: Blob;
  fileName: string;
}) => {
  if (Capacitor.isNativePlatform()) {
    const base64Data = await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64String = reader.result as string;
        resolve(base64String.split(",")[1]);
      };
    });
    await Filesystem.requestPermissions();

    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
      recursive: true,
    });
    await FileOpener.open({
      filePath: result.uri,
      openWithDefault: true,
    });
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};
